<template>
  <pt-detection-package-detail class="pt-detection-package-detail__page"></pt-detection-package-detail>
</template>

<script>
import PtDetectionPackageDetail from 'cps/gene-product/pt-detection-package-detail/withData'
export default {
  name: 'pt-detection-package-detail__view',
  components: {
    'pt-detection-package-detail': PtDetectionPackageDetail
  }
}
</script>
